import React from "react";
import { cn } from "@/lib/utils";

/**
 * Shared status pill — WCAG-AA accessible solid colour pairs, centered text, NO outline/border.
 * Design rule: pills are always solid (never outlined). Use a semantic `tone`.
 *
 * <StatusBadge tone="warning">Pending</StatusBadge>
 */
const TONES = {
  neutral: "bg-slate-200 text-slate-800",
  info: "bg-sky-100 text-sky-900",
  success: "bg-emerald-100 text-emerald-900",
  warning: "bg-amber-100 text-amber-900",
  danger: "bg-rose-100 text-rose-900",
  brand: "bg-teal-100 text-teal-900",
};

export function StatusBadge({ tone = "neutral", className, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold leading-normal",
        TONES[tone] || TONES.neutral,
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export const STATUS_TONES = Object.keys(TONES);
